import {useCallback, useEffect, useRef, useState} from 'react'

import {ProjectCardProps} from './types'

type UseTitleEditOptions = Pick<
  ProjectCardProps,
  'id' | 'title' | 'titleEditing' | 'onTitleSubmit'
>

export const useTitleEdit = ({
  id,
  title,
  titleEditing,
  onTitleSubmit
}: UseTitleEditOptions) => {
  const inputRef = useRef<HTMLInputElement>()
  const [value, setValue] = useState(title)

  useEffect(() => {
    const input = inputRef.current
    if (titleEditing && input) {
      const end = input.value.length
      input.setSelectionRange(end, end)
      input.scrollLeft = input.scrollWidth
      input.focus()
    }
  }, [title, titleEditing, setValue])

  const onCancel = useCallback(() => {
    setValue(title)
    onTitleSubmit?.(id)
    inputRef.current?.blur()
  }, [inputRef, id, title, setValue, onTitleSubmit])

  const onSubmit = useCallback(
    () => onTitleSubmit?.(id, value.trim()),
    [onTitleSubmit, id, value]
  )

  return {inputRef, title: value, setTitle: setValue, onCancel, onSubmit}
}
